<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div v-if="sectionData" class="wy-panel-tab-section-top panel-top-flex">

    <div class="change-over-time-component">
      <div class="change-overtime-info">
        <div class="bottom-left-stats-small-flex">
          <div v-if="sectionData.changeFromStart=='N/A' || Math.abs(sectionData.changeFromStart).toLocaleString('en-US')==100" class="value-previous-days no-data-value-previous-days">N/A</div> 
          <div v-else class="value-start-period" v-bind:class="{'positive arrow-up':sectionData.changeFromStart>0,'negative arrow-down':sectionData.changeFromStart<0, 'zero-percent': Math.abs(sectionData.changeFromStart).toLocaleString('en-US') == 0}">
            {{Math.abs(sectionData.changeFromStart).toLocaleString('en-US') == 0 ? "0.00" : Math.abs(sectionData.changeFromStart).toLocaleString('en-US')}}%
          </div> 
 
          <span class="change-over-time-texts" v-if="sectionData.changeFromStart=='N/A' || Math.abs(sectionData.changeFromStart).toLocaleString('en-US')==100">Correct comparison not available for this time period</span> 
          
          <span class="change-over-time-texts" v-else-if="sectionData.isTimeUnit">{{sectionData.endPeriodValue}} compared to {{sectionData.startPeriodValue}} from the start of the selected period (7 day RDA)</span> 
          
          <!-- <span class="change-over-time-texts" v-else-if="sectionData.startPeriodValue == 'N/A' || isNaN(sectionData.startPeriodValue) || Math.abs(sectionData.changeFromStart).toLocaleString('en-US')==100">Correct comparison not available for this time period</span>  -->
          
          <span class="change-over-time-texts" v-else>{{sectionData.prefix}}{{(Math.round(sectionData.endPeriodValue * 100) / 100).toLocaleString('en-US')}}{{sectionData.suffix}} compared to {{sectionData.prefix}}{{(Math.round(sectionData.startPeriodValue * 100) / 100).toLocaleString('en-US')}}{{sectionData.suffix}} from the start of the selected period (7 day RDA)</span>  

        </div>

        <div class="bottom-left-stats-small-flex">
          <div v-if="(!sectionData.changeOver30Days && sectionData.changeOver30Days!=0) || sectionData.changeOver30Days==100" class="value-previous-days no-data-value-previous-days">N/A</div> 
          <div v-else class="value-previous-days" v-bind:class="{'positive arrow-up':sectionData.changeOver30Days>0,'negative arrow-down':sectionData.changeOver30Days<0, 'zero-percent': Math.abs(sectionData.changeOver30Days).toLocaleString('en-US') == 0 }">
            {{Math.abs(sectionData.changeOver30Days).toLocaleString('en-US') == 0 ? "0.00" : Math.abs(sectionData.changeOver30Days).toLocaleString('en-US')}}%
          </div> 
          
          <span class="change-over-time-texts" v-if="sectionData.isTimeUnit">Compared to {{sectionData.daysPreviousValue}} over the previous {{sectionData.daysOvertimeRange}} days</span>

          <!-- <span class="change-over-time-texts" v-else-if="sectionData.daysPreviousValue == 'N/A' || isNaN(sectionData.daysPreviousValue)">Correct comparison not available for this time period</span> -->
          <span class="change-over-time-texts" v-else-if="(!sectionData.changeOver30Days && sectionData.changeOver30Days!=0) || sectionData.changeOver30Days==100">Correct comparison not available for this time period</span>

          <span class="change-over-time-texts" v-else>Compared to {{prefix}}{{(Math.round(sectionData.daysPreviousValue * 100) / 100).toLocaleString('en-US')}}{{suffix}} over the previous {{sectionData.daysOvertimeRange}} days</span>

        </div>
      </div>
    </div>

    <div v-if="sectionData && sectionData.lineChartData && !sectionData.multiChart" class="panel-top--title">
      {{sectionData.lineChartData.title}}
      <el-tooltip v-if="sectionData.lineChartData.tooltips" popper-class="sub-header-info-poppers" class="item" effect="dark" placement="bottom">
        <div slot="content"><span v-html="sectionData.lineChartData.tooltips"></span></div>
        <div class="icon-info-small"></div>
      </el-tooltip>
      <div v-else class="icon-info-small"></div>
    </div>

    <div v-if="sectionData && sectionData.pieChartData" class="panel-top--title">
      {{sectionData.pieChartData.title}}
      
      <el-tooltip  v-if="sectionData.pieChartData.tooltips" popper-class="sub-header-info-poppers" class="item" effect="dark" placement="bottom">
        <div slot="content"><span v-html="sectionData.pieChartData.tooltips"></span></div>
        <div class="icon-info-small"></div>
      </el-tooltip>
      <div v-else class="icon-info-small"></div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';

  export default Vue.extend({
    name: 'wy-panel-tab-section-top',
    props: ["sectionData"],
    computed: {
      suffix() {
        if(this.sectionData.valueSuffix) {
          return (this.sectionData.daysPreviousValue == 'N/A') ? '' : this.sectionData.valueSuffix;
        }
        else {
          return (this.sectionData.daysPreviousValue == 'N/A') ? '' : this.sectionData.suffix;
        }
      },
      prefix() {
        return (this.sectionData.daysPreviousValue == 'N/A') ? '' : this.sectionData.prefix;
      }
    },

  });
</script>

<style lang="scss">
.sub-header-info-poppers{
  font-family: Helvetica Neue, Helvetica;
  font-size: 14px;
}
.wy-panel-tab-section-top {
  .change-overtime-info{
    display: flex;
    margin-top: 10px;
  }
  .value-previous-days{
    // width: 65px;
    display: inline-block;
    // height: 36px;
    border: 1px solid transparent;
    background-color: #E6E7F8;
    border: 1px solid #AFB0DB;
    padding-left: 24px;
    padding-right: 10px;
    line-height: 36px;
    text-align: right;
    font-size: 18px;
    height: 36px;
  }
  .arrow-up {
    background: url('../../assets/icons/icon_performance_arrow_up.svg') no-repeat;
    background-position-y: 10.87px;
    background-position-x: 9px;
    background-size: 11.95px;
  }
  .arrow-down {
    background: url('../../assets/icons/icon_performance_arrow_down.svg') no-repeat;
    background-position-y: 10.87px;
    background-position-x: 9px;
    background-size: 11.95px;
  }
  .value-previous-days.positive{
    background-color: #E6E7F8;
    border: 1px solid #F4F4FC;
    color: #6446BB;
    border-radius: 30px;
  }
  .value-previous-days.negative{
    background-color: #EFFCFF;
    border: 1px solid #EFFCFF;
    color: #3961AE;
    border-radius: 30px;
  }
  .value-previous-days.zero-percent {
    background-color: #e4e8ec;
    border: 1px solid #e4e8ec;
    padding-right: 1.408vw !important;
    color: var(--site-font-tertiary-color);
    border-radius: 30px;
  }
  .value-previous-days.no-data-value-previous-days{
    background-color: #E4E8EC !important;
    border: none !important;
    padding-right: 1.408vw !important;
    padding-left: 1.408vw !important;
    color: var(--site-font-tertiary-color) !important;
    border-radius: 30px !important;
  }
  .value-start-period {
    // width: 65px;
    display: inline-block;
    // height: 36px;
    border: 1px solid transparent;
    background-color: #E6E7F8;
    border: 1px solid #AFB0DB;
    padding-left: 24px;
    padding-right: 10px;
    line-height: 36px;
    text-align: right;
    font-size: 18px;
    height: 36px;
  }
  .value-start-period.positive {
    background-color: #E6E7F8;
    border: 1px solid #F4F4FC;
    color: #6446BB;
    border-radius: 30px;
  }
  .value-start-period.negative {
    background-color: #EFFCFF;
    border: 1px solid #EFFCFF;
    color: #3961AE;
    border-radius: 30px;
  }
  .value-start-period.zero-percent {
    background-color: #e4e8ec;
    border: 1px solid #e4e8ec;
    padding-right: 1.408vw !important;
    color: var(--site-font-tertiary-color);
    border-radius: 30px;
  }
  .tab-section {
    display: block;
    background-color: #FFF;
  }
  .middle-flex{
    display: flex;
    border-bottom: 1px solid #CAD2DA;
  }
  .stats-component{
    display: flex;
    flex-direction: column;
    padding: 18px 15px;
  }
  .stats-component.containment-rate{
    border-bottom: 5px solid #0C2837;
  }
  .change-over-time-texts{
    font-size: 14.22px;
    font-family: Helvetica Neue, Helvetica;
    color: var(--site-font-tertiary-color);
    font-weight: normal;
    padding: 0px 10px 0 10px;
  }
  .panel-top--title {
    padding: 15px 15px 0 15px;
    font-size: 14.5px;
    font-weight: medium;
    color: var(--site-font-secondary-color);
  }
  .bottom-flex-title{
    padding: 15px 15px 0 15px;
    font-size: 14.5px;
    font-weight: medium;
    color: var(--site-font-secondary-color);
    height: 2.6vw;
  }
  .top-flex{
    display: flex;
    padding: 15px;
    background-color: #FFF;
    padding-bottom: 4px;
    border-bottom: 1px solid #CAD2DA;
    font-size: 18px;
    justify-content: space-between;
    margin-top: 3px;
    height: 42px;
  }
  .bottom-left-stats-small-flex{
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin: 15px 14px 0px 14px;
    width: 100% !important;

  }
  .icon-info{
    display: inline-block;
    background: url('../../assets/icons/icon_info_performance_overview.svg') no-repeat;
    width: 20px;
    height: 21px;
    position: relative;
    top: 7px;
    margin-left: 0.25vw;
  }
  #line-chart{
    position: relative;
    right: 1vw;
    // width: 450px;
    width: 100%;
    bottom: 40px;
  }
  .icon-info-small{
    display: inline-block;
    background: url('../../assets/icons/icon_info_small.svg') no-repeat;
    width: 20px;
    height: 21px;
    position: relative;
    top: 10px;
    right: 0.2vw;
    margin-left: 0.25vw;
  }
  .move-info{
    width: 23px;
    height: 33px;
    margin-left: 0.25vw;
    position: relative;
    top: -3px;
    right: 0.3vw;
  }
}
.wy-panel-tab-section-top.panel-top-flex {
  border-right: 1px #CAD2DA solid;
  // border-bottom: 1px #CAD2DA solid;
  // width: 337px;
  width: 100%;
  height: 118px
}
</style>